import type { Language } from '../content/content';

const STORAGE_KEY = 'albania-tour-language';

export function isLanguage(value: string | null): value is Language {
  return value === 'es' || value === 'en';
}

export function getStoredLanguage(): Language | null {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(STORAGE_KEY);
  return isLanguage(value) ? value : null;
}

export function setStoredLanguage(language: Language): void {
  window.localStorage.setItem(STORAGE_KEY, language);
}
